import { reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import {
  createProduct, editProduct, fetchProductDetail, fetchGroups, fetchProducts,
  clearAttachedProductImage, fetchCategories, fetchCategories2, fetchGroupCategories,
  fetchProductByNum, fetchProductsByCategory, fetchNextProduct, fetchPreviousProduct,
  fetchPackageTypes, setValue, resetCurrentProduct, clearCurrentProduct, reinitialize,
  fetchSmallProductInfo, setCurrentProduct, fetchMeasurementUnit, clearSmallProdStatus,
  fetchCRVValues, selectProduct, attachProductImage, fetchConvertableProducts,
  fetchDefaultBuyers, continueProduct, discontinueProduct, saveMobileDescriptionBoxText,
  duplicateProduct, updateProductGroup, deleteProduct, fetchDisplayCategories,
  editDisplayCategories, initializeESL, deleteESL, fetchESLTemplate, saveESL,
  fetchESL, fetchPreviousProductWithGeno, fetchNextProductWithGeno, verifyBarcode,
  fetchDeps, fetchDepCategories, fetchProductPartsList, fetchProductsByParams
} from '../../actions/products_actions';
import { fetchVendors, changeVendorValue } from '../../actions/vendors_actions';
import { fetchWarehouses, fetchWarehouseDetail } from '../../actions/warehouses_actions';
import { fetchZones, fetchBins, resetBins, getBinsByZone, getLevelsByBin } from '../../actions/zones_actions';
import { setDefaultOfForm } from '../../actions/purchaseOrders_actions';
import { selectInventory } from '../../actions/inventories_actions';
import { fetchPromoDetails } from '../../actions/promotions_actions';
import { fetchProductInventoryBatches, postProductInventoryBatches } from '../../actions/wholesaleModal_actions';
import { checkPermission, checkPassword, clearCheckPassword } from '../../actions/settings_actions';
import ProductForm from '../../components/Products/productForm';
import { handleInventoryClick } from '../../actions/inventories_actions';
import { setConfirmPasscodeModalVisibility, setPasscodeVerificationStatus } from '../../actions/baseModal_actions';
import { ROOT_URL, ROOT_API_URL, isHMM, isSKH, isSV, isGGI } from 'RootUrl';
import { fetchMarketInfo } from '../../actions/market_action';

const isUSPride =  ROOT_API_URL === "https://uspride-scm.truckxi.com/api/" || ROOT_API_URL === "https://uspride-scm.truckxi.com/api/";

const isNumeric = function (n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

const validate = (values) => {
  const errors = {};
  if (values.NetWeight && !isNumeric(values.NetWeight)) {
    errors.NetWeight = 'Accept number only!';
  }
  if (values.CaseWt && !isNumeric(values.CaseWt)) {
    errors.CaseWt = 'Accept number only!';
  }
  if (values.ShippingWeight && !isNumeric(values.ShippingWeight)) {
    errors.ShippingWeight = 'Accept number only!';
  }
  if (values.CRV && !isNumeric(values.CRV)) {
    errors.CRV = 'Accept number only!';
  }
  if (!values.ProductType) {
    errors.ProductType = 'Required';
  }
  if (values.RefPrice === '' || values.RefPrice === null || values.RefPrice === undefined) {
    errors.RefPrice = 'Required';
  }
  if (values.RefPrice && !isNumeric(values.RefPrice)) {
    errors.RefPrice = 'Accept number only!';
  }
  if (values.LowestSalePrice === '' || values.LowestSalePrice === null || values.LowestSalePrice === undefined) {
    errors.LowestSalePrice = 'Required';
  }
  if (values.LowestSalePrice && !isNumeric(values.LowestSalePrice)) {
    errors.LowestSalePrice = 'Accept number only!';
  }

  if (!values.ConvertType) {
    errors.ConvertType = 'Required';
  }

  if (!values.Name) {
    errors.Name = 'Required';
  }
  if (!values.RefNum && isSKH) {
    errors.RefNum = 'Required';
  }
  if (!values.UPC && isSKH) {
    errors.UPC = 'Required';
  }

  return errors;
};

const productForm = reduxForm({
  form: 'productForm',
  destroyOnUnmount: true,
  enableReinitialize: true,
  touchOnChange: true,
  touchOnBlur: false,
  validate,
})(ProductForm);

const selector = formValueSelector('productForm');

function mapStateToProps(state) {
  const DimensionUnit = selector(state, 'DimensionUnit');
  const DimensionHeight = selector(state, 'DimensionHeight');
  const DimensionLength = selector(state, 'DimensionLength');
  const DimensionWidth = selector(state, 'DimensionWidth');
  const BoxDimensionHeight = selector(state, 'BoxDimensionHeight');
  const BoxDimensionLength = selector(state, 'BoxDimensionLength');
  const BoxDimensionWidth = selector(state, 'BoxDimensionWidth');
  const UnitCBM = selector(state, 'UnitCBM');
  const UnitCBF = selector(state, 'UnitCBF');

  // CartonWidth, CartonHeight, CartonLength, CartonWeight
  const CartonWidth = selector(state, 'CartonWidth');
  const CartonHeight = selector(state, 'CartonHeight');
  const CartonLength = selector(state, 'CartonLength');
  const CartonWeight = selector(state, 'CartonWeight');

  const CaseHeight = selector(state, 'CaseHeight');
  const CaseLength = selector(state, 'CaseLength');
  const CaseWidth = selector(state, 'CaseWidth');
  const CaseCBM = selector(state, 'CaseCBM');
  const CaseCBF = selector(state, 'CaseCBF');

  const PalletHeight = selector(state, 'PalletHeight');
  const PalletLength = selector(state, 'PalletLength');
  const PalletWidth = selector(state, 'PalletWidth');
  const PalletCBM = selector(state, 'PalletCBM');
  const PalletCBF = selector(state, 'PalletCBF');
  const CasePerPallet = selector(state, 'CasePerPallet');

  const BoxWt = selector(state, 'BoxWt');
  const PromoTier1Qty = selector(state, 'PromoTier1Qty');
  const PromoTier2Qty = selector(state, 'PromoTier2Qty');

  const Pricelv1Value = selector(state, 'PriceLv1');
  const Pricelv2Value = selector(state, 'PriceLv2');
  const Pricelv3Value = selector(state, 'PriceLv3');
  const Pricelv4Value = selector(state, 'PriceLv4');
  const Pricelv5Value = selector(state, 'PriceLv5');
  const RefPriceValue = selector(state, 'RefPrice');
  const Default_Warehouse_id = selector(state, 'Default_Warehouse_id');
  const ProductGroup_id = selector(state, 'ProductGroup_id');
  const ProductDepartment_id = selector(state, 'ProductDepartment_id');
  const ProductNumber = selector(state, 'ProductNumber');
  const GeneralNumber = selector(state, 'GeneralNumber');
  const ConvertProductNum = selector(state, 'ConvertProductNum');
  const ConvertNum = selector(state, 'ConvertNum');
  const Related_Product_id = selector(state, 'Related_Product_id');
  const ProductType = selector(state, 'ProductType');
  const ProductNum = selector(state, 'ProductNum');
  const PackageSize_1 = selector(state, 'PackageSize_1');
  const PackageType_2 = selector(state, 'PackageType_2');
  const PackageSize_2 = selector(state, 'PackageSize_2');
  const MeasureUnit_2 = selector(state, 'MeasureUnit_2');
  const PackageSize_3 = selector(state, 'PackageSize_3');
  const MeasureUnit_3 = selector(state, 'MeasureUnit_3');
  const PackageSize = selector(state, 'PackageSize');
  const ConvertType = selector(state, 'ConvertType');
  const NetWeight = selector(state, 'NetWeight');
  const CaseWt = selector(state, 'CaseWt');

  const Units_Case = selector(state, 'Units_Case');
  const Units_InnerBox = selector(state, 'Units_InnerBox');

  const zoneID = selector(state, 'Default_WarehouseZone_id');
  const IsStopSale = selector(state, 'IsStopSale');
  const IsAllTaxable = selector(state, 'IsAllTaxable');
  const Zone = selector(state, 'Zone');
  const Bin = selector(state, 'Bin');
  const Level = selector(state, 'Level');
  const Zone2 = selector(state, 'Zone2');
  const Bin2 = selector(state, 'Bin2');
  const Level2 = selector(state, 'Level2');
  const Zone3 = selector(state, 'Zone3');
  const Bin3 = selector(state, 'Bin3');
  const Level3 = selector(state, 'Level3');
  const ProductCost = selector(state, 'ProductCost');
  const InStockPrice = selector(state, 'InStockPrice');
  const SurchargeUnitPrice = selector(state, 'SurchargeUnitPrice');
  const ShippingFeeUnitPrice = selector(state, 'ShippingFeeUnitPrice');
  const TaxAmount = selector(state, 'TaxAmount');
  const MiscUnitPrice = selector(state, 'MiscUnitPrice');
  const CustomDutyPercent = selector(state, 'CustomDutyPercent');
  const BaseCost = selector(state, 'BaseCost');
  const English_Details_Brand = selector(state, 'English_Details_Brand');
  const Chinese_Details_Brand = selector(state, 'Chinese_Details_Brand');
  const English_Brand_Origin = selector(state, 'English_Brand_Origin');
  const Chinese_Brand_Origin = selector(state, 'Chinese_Brand_Origin');
  const English_Details_NetContent = selector(state, 'English_Details_NetContent');
  const Chinese_Details_NetContent = selector(state, 'Chinese_Details_NetContent');
  const English_Details_Made_In = selector(state, 'English_Details_Made_In');
  const Chinese_Details_Made_In = selector(state, 'Chinese_Details_Made_In');
  const English_Details_Organic = selector(state, 'English_Details_Organic');
  const Chinese_Details_Organic = selector(state, 'Chinese_Details_Organic');
  const English_Details_Contains_Sugar = selector(state, 'English_Details_Contains_Sugar');
  const Chinese_Details_Contains_Sugar = selector(state, 'Chinese_Details_Contains_Sugar');
  const English_Details_Flavor = selector(state, 'English_Details_Flavor');
  const Chinese_Details_Flavor = selector(state, 'Chinese_Details_Flavor');
  const English_Details_Ingredients = selector(state, 'English_Details_Ingredients');
  const Chinese_Details_Ingredients = selector(state, 'Chinese_Details_Ingredients');
  const RefNum = selector(state, 'RefNum');
  const IsSyncToESL = selector(state, 'IsSyncToESL');
  const RefPriceMode = selector(state, 'RefPriceMode');
  const LevelType = selector(state, 'LevelType');

  // angel dear
  const Type = selector(state, 'Type');
  const ShortDescription = selector(state, 'ShortDescription');
  const Gender = selector(state, 'Gender');
  const NRF_Color_Code = selector(state, 'NRF_Color_Code');
  const NRF_Size_Code = selector(state, 'NRF_Size_Code');
  const US_HTS_Codes = selector(state, 'US_HTS_Codes');
  const CartonVolume = selector(state, 'CartonVolume');
  const CartonInnerQuantity = selector(state, 'CartonInnerQuantity');
  const CartonQuantity = selector(state, 'CartonQuantity');
  const ProductFamilySKU = selector(state, 'ProductFamilySKU');
  const ProductFamilyName = selector(state, 'ProductFamilyName');
  const ProductFamilyOption1Name = selector(state, 'ProductFamilyOption1Name');
  const ProductFamilyOption1Value = selector(state, 'ProductFamilyOption1Value');
  const ProductFamilyOption2Name = selector(state, 'ProductFamilyOption2Name');
  const ProductFamilyOption2Value = selector(state, 'ProductFamilyOption2Value');
  const ProductFamilyOption3Name = selector(state, 'ProductFamilyOption3Name');
  const ProductFamilyOption3Value = selector(state, 'ProductFamilyOption3Value');

  // Brands
  let ArrivalPrice;
  if(state.products.currentProductDetail) {
    ArrivalPrice = ( Number(ShippingFeeUnitPrice) + Number(ProductCost)).toFixed(4);
  }

  if(state.products.currentProductDetail && (isHMM || isUSPride)) {
    ArrivalPrice = (Number(ShippingFeeUnitPrice) + Number(TaxAmount) + Number(MiscUnitPrice) + Number(ProductCost)).toFixed(3);
  }

  let CustomDutyCost;
  if(state.products.currentProductDetail && isSV) {
    ArrivalPrice = ( Number(ShippingFeeUnitPrice) + Number(ProductCost) + Number(((CustomDutyPercent ? CustomDutyPercent : 0)/100)*BaseCost)).toFixed(4);
    CustomDutyCost = Number(((CustomDutyPercent ? CustomDutyPercent : 0)/100)*BaseCost).toFixed(4);
  }
  if(state.products.currentProductDetail && isGGI) {
    ArrivalPrice = ( Number(ShippingFeeUnitPrice) + Number(InStockPrice) + Number(SurchargeUnitPrice)).toFixed(4);
  }
  let market = [];
  if(isGGI && state.market.marketingAll.length > 0) {
    state.market.marketingAll.map((item)=>{
      market.push({...item, checked: false});
    })
    if(state.products.currentProductDetail && state.products.currentProductDetail.ProductMarketing_id.length > 0) {
      state.products.currentProductDetail.ProductMarketing_id.map((item)=>{
        market.map((it)=>{
          if(it.id == item){
            it.checked = true;
          }
        })
      })
    }
  }
  let selectMarket = [];
  if(isGGI && state.products.currentProductDetail && state.products.currentProductDetail.ProductMarketing_id.length > 0) {
    selectMarket = state.products.currentProductDetail.ProductMarketing_id;
  }

  let warehouseSelection = state.header.warehouses.map(({ Name, id, IsDefault, Company_id_id }) => ({
    label: Name,
    value: id + "",
    isDefault: IsDefault,
    companyId: Company_id_id,
  }));

  let initialValues = state.products.currentProductDetail;
  return {
    warehouseSelection,
    LevelType,
    IsSyncToESL,
    RefPriceMode,
    RefNum,
    PackageSize,
    MeasureUnit_3,
    PackageSize_3,
    ShippingFeeUnitPrice,
    ArrivalPrice,
    CustomDutyCost,
    ProductCost,
    InStockPrice,
    SurchargeUnitPrice,
    Default_Warehouse_id,
    DimensionUnit,
    DimensionHeight,
    DimensionLength,
    DimensionWidth,
    BoxDimensionHeight,
    BoxDimensionLength,
    BoxDimensionWidth,
    UnitCBM,
    UnitCBF,

    CartonWidth,
    CartonHeight,
    CartonLength,
    CartonWeight,

    CaseHeight,
    CaseLength,
    CaseWidth,
    CaseCBM,
    CaseCBF,

    PalletHeight,
    PalletLength,
    PalletWidth,
    PalletCBM,
    PalletCBF,
    CasePerPallet,

    BoxWt,
    PromoTier1Qty,
    PromoTier2Qty,

    Pricelv1Value,
    Pricelv2Value,
    Pricelv3Value,
    Pricelv4Value,
    Pricelv5Value,
    RefPriceValue,
    ProductGroup_id,
    ProductDepartment_id,
    ProductNumber,
    GeneralNumber,
    ConvertProductNum,
    ConvertNum,
    Related_Product_id,
    ProductType,
    ProductNum,
    PackageSize_1,
    PackageType_2,
    PackageSize_2,
    MeasureUnit_2,
    ConvertType,
    NetWeight,
    CaseWt,
    Units_Case,
    Units_InnerBox,
    zoneID,
    IsStopSale,
    IsAllTaxable,
    Zone,
    Bin,
    Level,
    Zone2,
    Bin2,
    Level2,
    Zone3,
    Bin3,
    Level3,
    English_Details_Brand,
    Chinese_Details_Brand,
    English_Brand_Origin,
    Chinese_Brand_Origin,
    English_Details_NetContent,
    Chinese_Details_NetContent,
    English_Details_Made_In,
    Chinese_Details_Made_In,
    English_Details_Organic,
    Chinese_Details_Organic,
    English_Details_Contains_Sugar,
    Chinese_Details_Contains_Sugar,
    English_Details_Flavor,
    Chinese_Details_Flavor,
    English_Details_Ingredients,
    Chinese_Details_Ingredients,

    // ? line 331 instead, zones: state.zones.all,
    // zones: state.zones.zones,
    bins: state.zones.bins,
    levels: state.zones.levels,
    zones2: state.zones.zones2,
    bins2: state.zones.bins2,
    levels2: state.zones.levels2,
    zones3: state.zones.zones3,
    bins3: state.zones.bins3,
    levels3: state.zones.levels3,
    currentProduct: state.products.currentProduct,
    currentProductDetail: state.products.currentProductDetail,
    detailIsLoading: state.products.detailIsLoading,
    detailError: state.products.detailError,
    initialValues,
    isCreating: state.products.isCreating,
    createError: state.products.createError,
    created: state.products.created,
    isEditing: state.products.isEditing,
    editError: state.products.editError,
    edited: state.products.edited,
    products: state.products.all,
    productIsLoading: state.products.isLoading,
    productError: state.products.error,
    vendors: state.vendors.all,
    vendorIsLoading: state.vendors.isLoading,
    vendorError: state.vendors.error,
    groups: state.products.groups,
    deps: state.products.deps,
    depCategories: state.products.depCategories,
    groupIsLoading: state.products.groupIsLoading,
    groupError: state.products.groupError,
    categories: state.products.categories,
    categoryIsLoading: state.products.categoryIsLoading,
    categoryError: state.products.categoryError,
    categories2: state.products.categories2,
    category2IsLoading: state.products.category2IsLoading,
    category2Error: state.products.category2Error,
    display_categories: state.products.display_categories,
    editCategoryLoading: state.products.editCategoryLoading,
    groupCategories: state.products.groupCategories,
    groupCategoryError: state.products.groupCategoryError,
    groupCategoryIsLoading: state.products.groupCategoryIsLoading,
    warehouses: state.warehouses.all,
    warehouseIsLoading: state.warehouses.isLoading,
    warehouseError: state.warehouses.error,
    productInventory: state.wholesaleModal.productInventory,
    zones: state.zones.all,
    zoneError: state.zones.error,
    zoneIsLoading: state.zones.isLoading,
    binError: state.zones.binError,
    binIsLoading: state.zones.binIsLoading,
    VendorID: selector(state, 'Vendor_id2'),
    currentWarehouseDetail: state.warehouses.currentWarehouseDetail,
    userPermissions: state.auth.userPermissions,

    smallProductDetail: state.products.smallProductDetail,
    smallProductDetailIsLoading: state.products.smallProductDetailIsLoading,
    smallProductDetailError: state.products.smallProductDetailError,
    CRVs: state.products.CRVs,
    CRVsIsLoading: state.products.CRVsIsLoading,
    CRVsError: state.products.CRVsError,
    productSaved: state.products.productSaved,
    defaultBuyers: state.products.defaultBuyers,
    defaultBuyersIsLoading: state.products.defaultBuyersIsLoading,
    defaultBuyersError: state.products.defaultBuyersError,

    originPage: state.inventories.originPage,

    attachingProductImage: state.products.attachingProductImage,
    productImageAttached: state.products.productImageAttached,
    fetchingConvertableProducts: state.products.fetchingConvertableProducts,
    convertableProductsFetched: state.products.convertableProductsFetched,
    convertableProductsFetchError: state.products.convertableProductsFetchError,
    fetchingProductPartsList: state.products.fetchingProductPartsList,
    productPartsListFetched: state.products.productPartsListFetched,
    productPartsListFetchError: state.products.productPartsListFetchError,

    packageTypesFetched: state.products.packageTypesFetched,
    fetchingPackageTypes: state.products.fetchingPackageTypes,
    packageTypeFetchError: state.products.packageTypeFetchError,
    measurementUnitFetched: state.products.measurementUnitFetched,
    fetchingMeasurementUnit: state.products.fetchingMeasurementUnit,
    measurementUnitFetchError: state.products.measurementUnitFetchError,

    promotionDetails: state.promotions.promotionDetails,
    promotionDetailsIsLoading: state.promotions.promotionDetailsIsLoading,
    promotionDetailsError: state.promotions.promotionDetailsError,

    continueOrDiscontinueProductError: state.products.continueOrDiscontinueProductError,
    continueOrDiscontinueProductSuccess: state.products.continueOrDiscontinueProductSuccess,

    checkingPermission: state.settings.checkingPermission,
    checkPermissionSuccess: state.settings.checkPermissionSuccess,
    checkPermissionFailure: state.settings.checkPermissionFailure,

    checkPassword: state.settings.checkPassword,
    checkPasswordSuccess: state.settings.checkPasswordSuccess,
    checkPasswordFailure: state.settings.checkPasswordFailure,

    isLoadingDescriptionBoxSave: state.products.savingMobileDescriptionText,
    saveMobileDescriptionTextSuccess: state.products.saveMobileDescriptionTextSuccess,

    deleteProductSuccess: state.products.deleteProductSuccess,
    deleteProductError: state.products.deleteProductError,
    
    confirmPasscodeModal: state.baseModals.confirmPasscodeModal,
    selectedCompany: state.header.selectedCompany,
    selectedWarehouse: state.header.selectedWarehouse,
    marketingAll: market,
    selectMarket,
    locale: state.i18n.locale,
  };
}

export default connect(mapStateToProps, {
  fetchWarehouseDetail,
  fetchVendors,
  createProduct,
  clearAttachedProductImage,
  fetchPackageTypes,
  fetchBins,
  resetBins,
  editProduct,
  fetchProductDetail,
  fetchProductInventoryBatches,
  postProductInventoryBatches,
  setCurrentProduct,
  setDefaultOfForm,
  fetchConvertableProducts,
  fetchProductPartsList,
  fetchGroups,
  changeVendorValue,
  change,
  fetchProducts,
  fetchCategories,
  fetchCategories2,
  fetchGroupCategories,
  fetchZones,
  fetchWarehouses,
  fetchProductByNum,
  fetchProductsByCategory,
  fetchNextProduct,
  fetchPreviousProduct,
  fetchPreviousProductWithGeno,
  fetchNextProductWithGeno,
  setValue,
  fetchMeasurementUnit,
  resetCurrentProduct,
  clearCurrentProduct,
  reinitialize,
  fetchSmallProductInfo,
  clearSmallProdStatus,
  fetchCRVValues,
  selectProduct,
  attachProductImage,
  selectInventory,
  fetchPromoDetails,
  checkPermission,
  checkPassword,
  clearCheckPassword,
  fetchDefaultBuyers,
  continueProduct,
  discontinueProduct,
  saveMobileDescriptionBoxText,
  duplicateProduct,
  updateProductGroup,
  deleteProduct,
  getBinsByZone,
  getLevelsByBin,
  handleInventoryClick,
  fetchDisplayCategories,
  editDisplayCategories,
  setConfirmPasscodeModalVisibility,
  setPasscodeVerificationStatus,
  initializeESL,
  deleteESL,
  fetchESLTemplate,
  saveESL,
  fetchESL,
  fetchDeps,
  fetchDepCategories,
  verifyBarcode,
  fetchMarketInfo,
  fetchProductsByParams,
})(productForm);

// fields!: ['Product_id', 'ProductNum', 'GeneralNum', 'RefNum', 'Name', 'Description', 'Description2', 'Relate_Product_id', 'ProductGroup_id',
//     'ProductCategory1_id', 'ProductCategory2_id', 'Vendor_id', 'Default_Warehouse_id', 'Default_WarehouseLoaction_id',
//     'Default_WarehouseZone_id', 'Default_WarehouseBin_id', 'PackageType_id', 'PackageSize', 'Width', 'Length', 'Height',
//     'MeasureUnit', 'NetWeight', 'ShippingWeight', 'MaxWeightRange', 'MinWeightRange', 'MaxStockRange', 'MinStockRange',
//     'ShiftLife', 'ProductType_id', 'Purchasor_User_id', 'ProductBarcode', 'RefBarcode', 'Discontinued', 'Taxable', 'OverSaleable',
//     'Promotion', 'StopSale', 'NetCost', 'ItemCost', 'LowestSalePrice', 'RefPrice']



// WEBPACK FOOTER //
// ./master/jsx/containers/Products/productForm.jsx